<template>
  <div class="card card-profile">
    <img
      src="../../assets/img/bg-profile.jpg"
      alt="Image placeholder"
      class="card-img-top"
    />
    <div class="row justify-content-center">
      <div class="col-4 col-lg-4 order-lg-2">
        <div class="mt-n4 mt-lg-n6 mb-4 mb-lg-0">
          <a href="javascript:;">
            <img
              src="../../assets/img/team-2.jpg"
              class="rounded-circle img-fluid border border-2 border-white"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="card-header text-center border-0 pt-0 pt-lg-2 pb-4 pb-lg-3">
      <div class="d-flex justify-content-between">
        <a
          href="javascript:;"
          class="btn btn-sm btn-info mb-0 d-none d-lg-block"
          >Contacto</a
        >
        <a
          href="javascript:;"
          class="btn btn-sm btn-info mb-0 d-block d-lg-none"
        >
          <i class="ni ni-collection"></i>
        </a>
        <a
          href="javascript:;"
          class="btn btn-sm btn-dark float-right mb-0 d-none d-lg-block"
          >Mensaje</a
        >
        <a
          href="javascript:;"
          class="btn btn-sm btn-dark float-right mb-0 d-block d-lg-none"
        >
          <i class="ni ni-email-83"></i>
        </a>
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="row">
      </div>
      <div class="text-center mt-4">
        <h5>
          <span class="font-weight-light">{{ nombreGerente }}</span>
        </h5>
        <div class="h6 font-weight-300">
          <i class="ni location_pin mr-2"></i>{{ email }}
        </div>
        <div>
          <i class="ni education_hat mr-2"></i>{{ telefono }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import usuario from "../../api/usuario";
// import Swal from "sweetalert2";
export default {
  props: ['gerente'],
  async mounted() {
    await this.getGerente()
  },
  data() {
    return {
      nombreGerente: "nombreGerente",
      email: "email",
      tipo:"tipo",
      telefono:"00000000",
      model:{
        gerente:""
      }
    };
  },
  methods: {
    getGerente() {
      this.model.gerente= this.gerente
      usuario
        .getGerente(this.model)
        .then((result) => {
          console.log(result.data[0])
          this.nombreGerente= result.data[0].nombre + " " + result.data[0].paterno + " " + result.data[0].materno
          this.telefono = result.data[0].telefono
          this.email = result.data[0].email
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goto() {
      this.$router.push({ path: "/registro" });
    },
  },
};
</script>
